import script from "./Quadro.vue?vue&type=script&setup=true&lang=js"
export * from "./Quadro.vue?vue&type=script&setup=true&lang=js"

import "./Quadro.vue?vue&type=style&index=0&id=522f44d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522f44d6"]])

export default __exports__